module.exports = "/_next/static/images/upalt-718c843cd4c9fd65f3d71cfda4a1a6d6.svg";